module.exports = __webpack_public_path__ + "static/media/S (162).4e44630a.jpg";